import { Navigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { GuideHero } from "../components/learn/GuideHero";
import { GuideBody } from "../components/learn/GuideBody";
import { GuideDepth, GuideNextDoors } from "../components/learn/GuideFooter";
import { getGuide } from "../content/learnGuides";
import "../styles/learn-guide.css";

export default function LearnGuide() {
  const { guideSlug } = useParams();
  const guide = getGuide(guideSlug);
  if (!guide) return <Navigate to="/learn" replace />;

  const title = `${guide.titleLead}${guide.titleAccent}${guide.titleTail}`.trim();
  return (
    <main className="learn-guide min-h-screen bg-aubergine" data-testid={`learn-guide-${guide.slug}`}>
      <Helmet>
        <title>{`${title} | Learn | T-REX Network`}</title>
        <meta name="description" content={guide.dek} />
        <meta property="og:title" content={`${title} | T-REX Network`} />
        <meta property="og:description" content={guide.dek} />
        <meta property="og:type" content="article" />
      </Helmet>
      <Navbar />
      <GuideHero guide={guide} />
      <GuideBody guide={guide} />
      <GuideDepth depth={guide.depth} />
      <GuideNextDoors currentSlug={guide.slug} />
      <Footer />
    </main>
  );
}
